
import { defineComponent, ref } from 'vue'
import { createRandom } from '@/services/account'
import WordList from '@/components/common/WordList.vue'
import BaseButton from '@/components/base/BaseButton.vue'

export default defineComponent({
  name: 'CraeteWallet',
  components: {
    WordList,
    BaseButton
  },
  emits: ['nextStep'],
  setup(_, { emit }) {
    const wallet = createRandom()
    const mnemonic = wallet.mnemonic.phrase.split(' ')
    const agree = ref(false)

    function continueToConfirm() {
      emit('nextStep', 3)
    }

    return {
      mnemonic,
      continueToConfirm,
      agree
    }
  }
})
